export default "__VITE_ASSET__ubShNJz$__"